import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Construct} from 'classes/construct';
import {environment} from 'environment';

@Injectable()
export class ConstructListRepository {

  constructor(private http: Http) { }

  public getUndistributedConstructs(full: boolean): Observable<Array<Construct>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.undistributedConstructs}` + (full ? '' : '?type=short'), options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawConstructs: Array<Construct>) => {
        return this.mapToConstructs(rawConstructs, full);
      });
  }

  public getConstructById(id: number): Observable<Construct> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.get(`${environment.constructs}/${id}`, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawConstruct: Construct) => {
        return Construct.create(rawConstruct);
      });
  }

  private mapToConstructs(rawConstructs: Array<Construct>, full: boolean): Array<Construct> {
    if (full) {
      return rawConstructs.map((rawConstruct) => {
        return Construct.create(rawConstruct);
      });
    }
    return rawConstructs.map((rawConstruct) => {
      return Construct.createLight2(rawConstruct);
    });
}
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-details/construct-list/repositories/construct-list.repository.ts